// Tuğla & Duvar Mock Data
// Tuğla siparişleri, palet takibi ve stok yönetimi

export const tuglaSiparisler = [
    {
        id: 'tg-001',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-10',
        tedarikci: 'Erbakan Tuğla',
        tedarikciFirmaId: 'f-020',
        miktar: 5000,
        birim: 'adet',
        tur: '13.5 Yatay Delikli',
        birimFiyat: 8.5,
        toplamFiyat: 42500,
        durum: 'teslim',
        paletSayisi: 20,
        insaatId: 'c1',
        kullanimAlani: 'A Blok - İç Duvarlar',
        stokMiktar: 1200,
        kullanilanMiktar: 3800,
        not: 'İç duvar örme için',
        createdAt: '2026-01-08T08:00:00Z',
        updatedAt: '2026-01-15T10:00:00Z',
    },
    {
        id: 'tg-002',
        siparisTarihi: '2026-01-09',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Erbakan Tuğla',
        tedarikciFirmaId: 'f-020',
        miktar: 3000,
        birim: 'adet',
        tur: '19 Yatay Delikli',
        birimFiyat: 12,
        toplamFiyat: 36000,
        durum: 'teslim',
        paletSayisi: 12,
        insaatId: 'c1',
        kullanimAlani: 'A Blok - Dış Duvarlar',
        stokMiktar: 800,
        kullanilanMiktar: 2200,
        not: 'Dış cephe duvar örme',
        createdAt: '2026-01-09T09:00:00Z',
        updatedAt: '2026-01-16T14:00:00Z',
    },
    {
        id: 'tg-003',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-14',
        tedarikci: 'Kilsan Tuğla',
        tedarikciFirmaId: 'f-021',
        miktar: 2000,
        birim: 'adet',
        tur: 'Gazbeton Blok 20cm',
        birimFiyat: 22,
        toplamFiyat: 44000,
        durum: 'teslim',
        paletSayisi: 10,
        insaatId: 'c1',
        kullanimAlani: 'B Blok - İç Duvarlar',
        stokMiktar: 500,
        kullanilanMiktar: 1500,
        not: 'Hafif bölme duvar',
        createdAt: '2026-01-12T10:00:00Z',
        updatedAt: '2026-01-18T12:00:00Z',
    },
    {
        id: 'tg-004',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'Erbakan Tuğla',
        tedarikciFirmaId: 'f-020',
        miktar: 4000,
        birim: 'adet',
        tur: '13.5 Yatay Delikli',
        birimFiyat: 8.5,
        toplamFiyat: 34000,
        durum: 'bekliyor',
        paletSayisi: 16,
        insaatId: 'c1',
        kullanimAlani: 'B Blok - İç Duvarlar',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        not: '2. ve 3. kat duvar işleri',
        createdAt: '2026-01-15T11:00:00Z',
        updatedAt: '2026-01-15T11:00:00Z',
    },
    {
        id: 'tg-005',
        siparisTarihi: '2026-01-06',
        teslimTarihi: '2026-01-08',
        tedarikci: 'Kilsan Tuğla',
        tedarikciFirmaId: 'f-021',
        miktar: 6000,
        birim: 'adet',
        tur: '8.5 Yatay Delikli',
        birimFiyat: 6,
        toplamFiyat: 36000,
        durum: 'teslim',
        paletSayisi: 24,
        insaatId: 'c1',
        kullanimAlani: 'A Blok - Bölme Duvarlar',
        stokMiktar: 200,
        kullanilanMiktar: 5800,
        not: 'İnce bölme duvarlar tamamlandı',
        createdAt: '2026-01-06T07:30:00Z',
        updatedAt: '2026-01-14T16:00:00Z',
    },
    {
        id: 'tg-006',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Ytong',
        tedarikciFirmaId: 'f-022',
        miktar: 1500,
        birim: 'adet',
        tur: 'Gazbeton Blok 10cm',
        birimFiyat: 15,
        toplamFiyat: 22500,
        durum: 'teslim',
        paletSayisi: 8,
        insaatId: 'c2',
        kullanimAlani: 'A Blok - Bölme Duvarlar',
        stokMiktar: 400,
        kullanilanMiktar: 1100,
        not: 'Banyo/WC bölme duvarları',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-16T10:00:00Z',
    },
    {
        id: 'tg-007',
        siparisTarihi: '2026-01-14',
        teslimTarihi: '2026-01-16',
        tedarikci: 'Erbakan Tuğla',
        tedarikciFirmaId: 'f-020',
        miktar: 8000,
        birim: 'adet',
        tur: '13.5 Yatay Delikli',
        birimFiyat: 8.5,
        toplamFiyat: 68000,
        durum: 'teslim',
        paletSayisi: 32,
        insaatId: 'c2',
        kullanimAlani: 'B Blok - İç Duvarlar',
        stokMiktar: 3000,
        kullanilanMiktar: 5000,
        not: 'Tüm katlar için sipariş',
        createdAt: '2026-01-14T09:00:00Z',
        updatedAt: '2026-01-20T15:00:00Z',
    },
    {
        id: 'tg-008',
        siparisTarihi: '2026-01-18',
        teslimTarihi: null,
        tedarikci: 'Ytong',
        tedarikciFirmaId: 'f-022',
        miktar: 2500,
        birim: 'adet',
        tur: 'Gazbeton Blok 15cm',
        birimFiyat: 18,
        toplamFiyat: 45000,
        durum: 'bekliyor',
        paletSayisi: 12,
        insaatId: 'c2',
        kullanimAlani: 'C Blok - Dış Duvarlar',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        not: 'Hafif dış cephe duvarı',
        createdAt: '2026-01-18T10:00:00Z',
        updatedAt: '2026-01-18T10:00:00Z',
    },
    {
        id: 'tg-009',
        siparisTarihi: '2026-01-11',
        teslimTarihi: '2026-01-13',
        tedarikci: 'Erbakan Tuğla',
        tedarikciFirmaId: 'f-020',
        miktar: 3500,
        birim: 'adet',
        tur: '19 Yatay Delikli',
        birimFiyat: 12,
        toplamFiyat: 42000,
        durum: 'teslim',
        paletSayisi: 14,
        insaatId: 'c2',
        kullanimAlani: 'A Blok - Dış Duvarlar',
        stokMiktar: 900,
        kullanilanMiktar: 2600,
        not: 'Dış cephe iç sıra',
        createdAt: '2026-01-11T08:30:00Z',
        updatedAt: '2026-01-17T14:00:00Z',
    },
    {
        id: 'tg-010',
        siparisTarihi: '2026-01-16',
        teslimTarihi: '2026-01-18',
        tedarikci: 'Kilsan Tuğla',
        tedarikciFirmaId: 'f-021',
        miktar: 1000,
        birim: 'adet',
        tur: 'Briket 20cm',
        birimFiyat: 10,
        toplamFiyat: 10000,
        durum: 'teslim',
        paletSayisi: 5,
        insaatId: 'c1',
        kullanimAlani: 'Ortak Alanlar',
        stokMiktar: 300,
        kullanilanMiktar: 700,
        not: 'Bodrum kat bölme duvarları',
        createdAt: '2026-01-16T07:00:00Z',
        updatedAt: '2026-01-20T11:00:00Z',
    },
    {
        id: 'tg-011',
        siparisTarihi: '2026-01-16',
        teslimTarihi: '2026-01-18',
        tedarikci: 'Kilsan Tuğla',
        tedarikciFirmaId: 'f-021',
        miktar: 1000,
        birim: 'adet',
        tur: 'Briket 20cm',
        birimFiyat: 10,
        toplamFiyat: 10000,
        durum: 'teslim',
        paletSayisi: 5,
        insaatId: 'c1',
        kullanimAlani: 'Ortak Alanlar',
        stokMiktar: 300,
        kullanilanMiktar: 700,
        not: 'Bodrum kat bölme duvarları',
        createdAt: '2026-01-16T07:00:00Z',
        updatedAt: '2026-01-20T11:00:00Z',
    },
];

// Tuğla türleri
export const tuglaTurleri = [
    { key: '8.5 Yatay Delikli', label: '8.5 Yatay Delikli', aciklama: 'İnce bölme duvar' },
    { key: '13.5 Yatay Delikli', label: '13.5 Yatay Delikli', aciklama: 'Standart iç duvar' },
    { key: '19 Yatay Delikli', label: '19 Yatay Delikli', aciklama: 'Dış cephe duvar' },
    { key: 'Gazbeton Blok 10cm', label: 'Gazbeton Blok 10cm', aciklama: 'Hafif bölme' },
    { key: 'Gazbeton Blok 15cm', label: 'Gazbeton Blok 15cm', aciklama: 'Hafif dış duvar' },
    { key: 'Gazbeton Blok 20cm', label: 'Gazbeton Blok 20cm', aciklama: 'Taşıyıcı hafif blok' },
    { key: 'Briket 20cm', label: 'Briket 20cm', aciklama: 'Bodrum / depo duvarı' },
];

// İstatistikler
export const getTuglaStats = (insaatId) => {
    const filtered = insaatId
        ? tuglaSiparisler.filter(s => s.insaatId === insaatId)
        : tuglaSiparisler;

    const toplamAdet = filtered.reduce((acc, s) => acc + s.miktar, 0);
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.miktar, 0);
    const bekleyen = filtered.filter(s => s.durum === 'bekliyor').reduce((acc, s) => acc + s.miktar, 0);
    const stokAdet = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.stokMiktar, 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return { toplamAdet, teslimEdilen, bekleyen, stokAdet, toplamMaliyet, siparisAdedi: filtered.length };
};

// Helper
export const getTuglaByInsaat = (insaatId) => {
    if (!insaatId) return tuglaSiparisler;
    return tuglaSiparisler.filter(s => s.insaatId === insaatId);
};
